import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})

export class ButtonComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() text: string;
  @Input() status;
  @Input() size: 'tiny' | 'normal';
  @Input() prefixIconSrc: string;
  @Input() suffixIconSrc: string;
  @Input() bgColor = '';
  @Input() type: 'primaryFilled' | 'primaryOutline' | 'primaryText' | 'secondaryFilled' |
    'plainOutline' | 'plainText' | 'icon' | 'reportDownload' | 'viewInvoice' | 'plainButton' |
     'login' | 'textOnly' | 'assignVendor' | 'actions-buttons' | 'action-button' | 'cancel-button' | 'cancel' | 'save-button' | 'removeStop';
  @Input() btnType: string;
  @Output() clickCallback = new EventEmitter();

  public className = '';

  ngOnInit() {
    switch (this.type) {
      case 'login': this.className = 'login-button'; break;
      case 'primaryFilled': this.className = 'primary-filled'; break;
      case 'viewInvoice': this.className = 'view-invoice'; break;
      case 'primaryOutline': this.className = 'primary-outline'; break;
      case 'primaryText': this.className = 'primary-text'; break;
      case 'secondaryFilled': this.className = 'secondary-filled'; break;
      case 'plainOutline': this.className = 'plain-outline'; break;
      case 'plainText': this.className = 'plain-text'; break;
      case 'icon': this.className = 'icon-button'; break;
      case 'reportDownload': this.className = 'download-button'; break;
      case 'assignVendor': this.className = 'assingVendor-button'; break;
      case 'plainButton': this.className = 'plainButton'; break;
      case 'textOnly': this.className = 'text-only'; break;
      case 'actions-buttons': this.className = 'action-ok'; break;
      case 'action-button': this.className = 'action-button'; break;
      case 'save-button': this.className = 'save-button'; break;
      case 'cancel-button': this.className = 'cancel-button'; break;
      case 'cancel': this.className = 'cancel'; break;
      case 'removeStop': this.className = 'removeStop'; break;
      default: this.className = 'plain-text'; break;
    }
  }

  onClick(): void {
    if (this.clickCallback) {
      this.clickCallback.emit();
    }
  }

  getColor(status) {
    // switch (status) {
    //   case 'APPROVED':
    //     return '#3cae4c';
    //   case 'PENDING':
    //     return 'blue';
    //   case 'REJECTED':
    //     return '#ff6468';
    // }
  }
}
